import React from 'react';
import '../../styles/components/MarkerPin.css';
import { HoveredCard } from './hoveredCard';
import location from "../../Images/location.png";

const MarkerPin = (props) => {
    const { src, redirectTo, defaultMarker, data, distance } = props;
    const [toggle, setToggle] = React.useState(false);
    return (
        defaultMarker ?
            <>
                <img alt="Location" className={` ${src === null ? "default_pin" : "pin"} bounce`} src={location}/>
                <div className="pulse" />
            </> :
                <div>
                    <div
                        className={` ${src === null ? "default_pin" : "pin"} bounce`}
                        style={{ backgroundColor: "#6AA403", cursor: 'pointer' }}
                        onClick={() => setToggle(!toggle)}
                    />
                    {(data?.length > 0 && toggle) && <div className='scroll_events_hovered_div'> {
                        data?.map(
                            ev =>
                            <HoveredCard key={ev.eventId} toggle={toggle} event={ev} distance={distance} redirectTo={redirectTo} />)}</div>}
                    
                    <span style={{ width: '200px', padding: '10px', display: 'flex', justifyContent: 'center', position: 'relative', left: '-110px' }} className='marker_div_event_heading'>{data[0]?.name}</span>
                </div >
    );
};

export default MarkerPin;